import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Checkbox, Chip, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DeleteModal from "../../../components/Common/DeleteModal.js";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import Header from "../../../components/VerticalLayout/Header.js";
import Helpers from "../../../helpers/helpers";
import { getGeneral, verify_admin } from "../../../store/actions.js";
import { deleteRole, getRole, resetRoleAttachmentState, resetRoleState } from "../../../store/role/action";
import "../setting.css";


const RolesAndPermissions = ({ roleListing, roleUserAssign, userPermission, delRoleArry }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [values, setFormValues] = useState({ status: '' });
  const [page, setPage] = useState(1);
  const [length, setLength] = useState("10");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("asc");
  const [sort_by, setSortBy] = useState("id");
  const [selectedRow, setSelectedRow] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [creatable, setCreatable] = useState(true);
  const [editable, setEditable] = useState(true);
  const [deletable, setDeletable] = useState(true);
  const [exportable, setExportable] = useState(true);
  const searchRef = useRef(keyword);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-role") && setCreatable(true);
      userPermission?.includes("update-role") && setEditable(true);
      userPermission?.includes("delete-role") && setDeletable(true);
      userPermission?.includes("export-role") && setExportable(true);
    }
  }, [userPermission])

  useEffect(() => {
    searchRef.current = keyword;
  }, [keyword]);

  useEffect(() => {
    dispatch(resetRoleState());
  }, []);

  useEffect(() => {
    initData();
  }, [page, length, sort, sort_by]);

  useEffect(() => {
    if (roleUserAssign?.code === 'success') {
      setNotification({
        open: true,
        msg: "User assign successfully",
        type: "success"
      })
      dispatch(resetRoleAttachmentState());
    }
    setIsLoading(false);
  }, [roleUserAssign])

  useEffect(() => {
    if (delRoleArry?.code === "success") {
      setDeleteOpen(false);
      setNotification({
        open: true,
        msg: "Delete Successfully",
        type: "success",
      });
      dispatch(resetRoleState());
      dispatch(getGeneral());
      dispatch(verify_admin());

      initData();
    } else if (delRoleArry?.code === "delete_failed") {
      setNotification({ open: true, msg: delRoleArry?.message, type: "error" });
      dispatch(resetRoleState());
      setSelectedRow("")
    }else if (delRoleArry?.code === "unauthorized") {
      setNotification({ open: true, msg: delRoleArry?.message, type: "error" });
      dispatch(resetRoleState());
      setSelectedRow("")
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delRoleArry]);

  const handleDelete = () => {
    if (selectedRow) {
      if (selectedRow?.length > 1)
        dispatch(deleteRole({
          id: {
            delete_ids: selectedRow
          }, multiple: true
        }));
      else
        dispatch(deleteRole({ id: selectedRow }));
    }
  }

  const initData = () => {
    let payload = {
      length: length,
      page: page,
      sortOrder: sort,
      sort: sort_by,
      search: searchRef.current
    }
    dispatch(getRole(payload));
  }

  const handleCheckboxChange = (e) => {
    let temp = []
    if (selectedRow && selectedRow?.includes(parseInt(e))) {
      temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
      setSelectedRow(temp)
    } else {
      setSelectedRow([...selectedRow, parseInt(e)])

    }
  }

  useEffect(() => {
    if (checkedAll) {
      let temp = roleListing?.data && roleListing?.data?.length > 0 ? roleListing?.data?.filter((x, idx) => x?.default !== 1) : []
      setSelectedRow(temp)
    } else {
      setSelectedRow("")
    }

  }, [checkedAll]);

  const header = [
    {
      Header: "#",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
           {cellProps?.default !== 1 && <Checkbox checked={checkedAll ? checkedAll : selectedRow && selectedRow?.length > 0 && selectedRow?.includes(cellProps.id)} sx={{
              '&.Mui-checked': {
                color: "#a0a0a0",
              },
              '& .MuiSvgIcon-root': {
                fontSize: 18,
              },
            }}
              value={cellProps.id}
              onChange={(event) => handleCheckboxChange(event.target.value)} />}
          </React.Fragment>
        )
      },
    },
    {
      Header: "Role ",
      columnID: "id",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps?.display_name || '-'} {cellProps?.default === 1 ? <Chip label={"Default"} sx={{ borderRadius: "5px", marginLeft: "10px" }} /> : ""}</div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "User Assigned",
      columnID: "user_count",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps?.user_count || 0} Users</div>
          </React.Fragment>
        )
      }, disableFilters: true,
      filterable: false,
    },
    {
      Header: "Permission",
      columnID: "permission",
      accessor: (cellProps) => {
        return (
          <>{cellProps?.permission || "-"}</>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Actions",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable && <Link to={`/edit-settings-roles/` + (cellProps.id)}>
              <CustomIconButton iconName={'fluent:edit-32-regular'} onClick={() => ''} />
            </Link>}
            {deletable && cellProps?.default === 0 &&
              <CustomIconButton iconName={'fluent:delete-32-regular'} onClick={() => { setSelectedRow(cellProps?.id); setDeleteOpen(true) }} />
            }</React.Fragment>
        )
      },
      minWidth: 120,
      position: 'sticky',
      disableFilters: true,
      filterable: false,
    }
  ]

  const handleExport = () => {
    setIsLoading(true);
    let filter = {
      search: keyword
    }
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    dispatch(roleUserAssign({
      sort: sort_by,
      sort_order: sort,
      filter: filter
    }));
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        initData();
      }
    }, Helpers.searchInterval);
  }

  const resetFilter = () => {
    handleSearch('');
  }

  const customToolsBar = () => {
    return (
      <Grid container spacing={2} mb={3} paddingBlock={1} justifyContent={"space-between"}>
        <Grid item xs={12} sm={6} className="d-flex align-items-end">
          <SearchBar
            value={keyword}
            setValue={(e) => handleSearch(e)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack gap={1} direction={{ xs: "column", sm: "row" }} className="d-flex justify-content-end">
            {deletable && <CustomButton
              title={<><Icon icon={'fluent:delete-32-regular'} style={{ marginRight: 5, color: '#525252CC' }} />Delete</>}
              press={() => {
                selectedRow?.length > 0 ? setDeleteOpen(true) : setNotification({
                  open: true,
                  msg: "Please select at least one item to delete.",
                  type: "error",
                })
              }
              } height={32}
              borderRadius={5}
              backgroundColor={'white'}
              textColor={'#000'}
              borderStyle={"1px solid #babcbe"}
            />}
            {
              creatable &&
              <CustomButton
                hoverColor="white"
                hoverBackgroundColor={"black"}
                title={<><Icon icon={"fluent:add-12-filled"} style={{ marginRight: '5px' }} />  New Role </>}
                textColor={'white'}
                height={32}
                press={() => navigate('/add-settings-roles')}
              />
            }
          </Stack>
        </Grid>

      </Grid>
    )
  }

  const onDel = () => {
    handleDelete()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <LoadingDialog open={loading || !roleListing?.data} /> */}
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Header
            breadcrumb={<Breadcrumbs
              breadcrumbItems={[{ title: "Roles", link: "#" },
              ]}
            >
            </Breadcrumbs>} />
          {customToolsBar()}
          <Table
            header={header}
            data={roleListing?.data || []}
            pageSize={length}
            totalPage={roleListing?.last_page}
            customToolsBar={true}
            setCheckedAll={setCheckedAll}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            checkedAll={checkedAll}
            sort={sort}
          />
          <TablePageControl
            from={roleListing?.from}
            to={roleListing?.to}
            total={roleListing?.total}
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={roleListing?.last_page}
          />
        </Container>
        <DeleteModal
          open={deleteOpen}
          close={() => setDeleteOpen(false)}
          submit={() => onDel()}
          module={'item'}
        />
      </div>
    </React.Fragment>
  );
};

function mapStateToProps({ Role, Login }) {
  return {
    roleListing: Role.role,
    roleUserAssign: Role.roleUserAssign,
    userPermission: Login.permissionArry,
    delRoleArry: Role?.delRole,

  };
}

export default connect(mapStateToProps)(RolesAndPermissions);